// extracted by mini-css-extract-plugin
module.exports = {"page":"page_page__rj2Wt","content":"page_content__iKuwR"};